import { useRef, useState } from "react";
import { toast } from "sonner";
import { Eraser, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { uploadFile, StoredImg } from "@/components/Uploads";

export const SignaturePad = ({ value, onChange }) => {
  const ref = useRef();
  const drawing = useRef(false);
  const [dirty, setDirty] = useState(false);
  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [(e.clientX - r.left) * (ref.current.width / r.width), (e.clientY - r.top) * (ref.current.height / r.height)]; };
  const down = (e) => { drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.lineWidth = 3; ctx.lineCap = "round"; ctx.strokeStyle = "#0F172A"; ctx.beginPath(); ctx.moveTo(...pos(e)); ref.current.setPointerCapture(e.pointerId); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); setDirty(true); };
  const clear = () => { ref.current.getContext("2d").clearRect(0, 0, 600, 240); setDirty(false); };
  const save = () => ref.current.toBlob(async (b) => {
    try { onChange((await uploadFile("photo", new File([b], "sign.png", { type: "image/png" }))).path); toast.success("Tanda tangan disimpan"); clear(); } catch { toast.error("Gagal menyimpan tanda tangan"); }
  }, "image/png");
  if (value) return (
    <div className="flex items-center gap-3" data-testid="signature-saved">
      <StoredImg path={value} className="h-20 rounded border bg-white" />
      <Button type="button" size="sm" variant="outline" onClick={() => onChange("")} data-testid="signature-redo-btn">Ulangi</Button>
    </div>
  );
  return (
    <div className="space-y-2">
      <canvas ref={ref} width={600} height={240} className="w-full max-w-md touch-none rounded-lg border-2 border-dashed border-slate-300 bg-white"
        onPointerDown={down} onPointerMove={move} onPointerUp={() => { drawing.current = false; }} data-testid="signature-canvas" />
      <div className="flex gap-2">
        <Button type="button" size="sm" variant="outline" onClick={clear} data-testid="signature-clear-btn"><Eraser className="h-4 w-4 mr-1" />Hapus</Button>
        <Button type="button" size="sm" disabled={!dirty} onClick={save} data-testid="signature-save-btn"><Check className="h-4 w-4 mr-1" />Simpan TTD</Button>
      </div>
    </div>
  );
};
